import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const euApi = AiseaApiFactory.get("enterpriseUser");

export default {
  async fetchUsers({ commit }, payload) {
    let response = await euApi.search(payload);
    commit("SET_USERS", response.data.users);
    commit("SET_PAGING", response.data.pageable);
    return response.data
  },

  async updateUsersSortOrder(_nouse, payload){
    let response = await euApi.updateSortOrder(payload);
    if ( !response || !response.status ) {
      throw response;
    }
  },

  async resetUserListState({ commit }) {
    let defaultState = {
      users: [],
      pageable: null
    };
    commit("RESET_STATE", defaultState);
  }
};
